import { AiFillTwitterCircle } from "react-icons/ai";
import { IoLogoFacebook } from "react-icons/io5";
import { RiInstagramFill } from "react-icons/ri";
import { footerItems } from "./navItems";

const Footer = () => {

   
    return (
        <div>
            <nav className="text-footerPrimary text-xs sm:text-sm bg-footerSecondary px-3 sm:px-4 md:px-6 lg:px-8 py-2 max-w-screen-2xl border-t mx-auto fixed bottom-0 right-0 left-0 h-[48px] md:h-[44px]">
                <div className="w-full mx-auto flex items-center justify-center md:justify-between font-medium h-full">
                    {/* Left Panel */}
                    <div className="flex items-center gap-3 sm:gap-4 min-w-0">
                        <a href="/" className="font-semibold flex items-center min-w-0">
                            <span className="truncate">&copy; Copyright</span>
                        </a>

                        {/* footer menu items */}
                        <ul className="hidden lg:flex space-x-6">
                            {
                                footerItems.map(({ link, path }) => <a key={link} href={path} className="block hover:text-gray-300">{link}</a>)
                            }
                        </ul>                       
                       
                    </div>

                    {/* Right Panel */}
                    <div className="hidden md:flex items-center gap-3 sm:gap-4">

                        {/* Version */}
                        <a href='#' className="hidden sm:block hover:text-gray-300">Version 1.0.0</a>

                        {/* Social Link */}
                        <a href="/" className="hidden md:flex items-center hover:text-secondary"><AiFillTwitterCircle className="text-xl" /><span></span></a>
                        <a href="/" className="hidden md:flex items-center hover:text-secondary"><IoLogoFacebook className="text-xl" /><span></span></a>
                        <a href="/" className="hidden md:flex items-center hover:text-secondary"><RiInstagramFill className="text-xl" /><span></span></a>
                       
                    </div>                   
                </div>
            </nav>            
        </div>
    )
}

export default Footer